import React from 'react';
import Modal from "./Modal.js";
import t from "../../scripts/i18n";
import "../../styling/components/common/ConfirmModal.css";

var ConfirmModal = function ConfirmModal(props) {
  var title = props.title,
      question = props.question,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      loading = props.loading;
  return /*#__PURE__*/React.createElement(Modal, {
    size: "md",
    isLoading: loading
  }, /*#__PURE__*/React.createElement("div", {
    className: "confirm-modal"
  }, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("p", null, question), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "secondary",
    onClick: onCancel
  }, t('confirm_modal_cancel')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: onConfirm
  }, t('confirm_modal_confirm')))));
};

export default ConfirmModal;